import { lazyWithRetry } from "@/react/lazyWithRetry";
import type { ClientActionDescriptor } from "@/managers/ClientActionRegistry";

// connectors-catalog — the Connector Manager client action (connectors Enh 01).
//
// The seeded `ir.action` row (`connectors.action_catalog` in
// `data/connectors_menus.xml`) declares `client_component="connectors-catalog"`;
// this descriptor binds that identifier to the React page. Vite's eager glob in
// `clientActionsDiscovery.ts` discovers this file at boot.
//
// Lazy-loaded so the catalogue + wizard stay out of the initial bundle for
// users who never open Settings → Connectors.
const ConnectorsCatalog = lazyWithRetry(() => import("../components/ConnectorsCatalog"), "connectors-catalog");

const plugin: ClientActionDescriptor = {
    key: "connectors-catalog",
    component: ConnectorsCatalog,
    paramSchema: "any",
};

export default plugin;
